"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var channels = {};

var getChannel = function getChannel(channelName) {
  return channels[channelName] || [];
};
var setChannel = function setChannel(channelName, value) {
  channels[channelName] = value;
};

var subscribe = exports.subscribe = function subscribe(channelName, cb) {
  var channel = getChannel(channelName);
  channel = [].concat(_toConsumableArray(channel), [cb]);
  setChannel(channelName, channel);
};

var publish = exports.publish = function publish(channelName) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  getChannel(channelName).forEach(function (cb) {
    return cb.apply(undefined, args);
  });
};

var unsubscribe = exports.unsubscribe = function unsubscribe(channelName, cb) {
  var channel = getChannel(channelName);
  var index = channel.findIndex(function (cbItem) {
    return cbItem === cb;
  });
  if (index >= 0) {
    channel.splice(index, 1);
    setChannel(channelName, channel);
  }
};

var cleanChannels = exports.cleanChannels = function cleanChannels() {
  channels = {};
};

exports.default = {
  subscribe: subscribe,
  publish: publish,
  unsubscribe: unsubscribe,
  cleanChannels: cleanChannels
};
//# sourceMappingURL=mediator.js.map